module.exports = __webpack_public_path__ + "static/media/wholesale.f30184ad.png";